import { getQueryParam } from '../shared/utils.js';
import { elements } from './elements.js';
import { expandFilterMenu } from '../../../includes/collapseFilterGroup.js';
import Choices from 'choices.js';

export const preloadFormFields = () => {
    const { searchInput, regionRadios, formatSelect, yearSelect, genreSelect, availableToWatchCheckbox } = elements;

    if (searchInput) {
        searchInput.value = getQueryParam('q') || '';
    }
    if (regionRadios) {
        const region = getQueryParam('region') ?? '';
        regionRadios.forEach((radio) => {
            radio.checked = radio.value === region;
        });
    }
    const allChoices = {};
    if (formatSelect) {
        formatSelect.value = getQueryParam('format') || '';
        const choices = new Choices(formatSelect, {
            searchEnabled: false
        });
        allChoices[formatSelect.name] = choices;
    }
    if (yearSelect) {
        yearSelect.value = getQueryParam('year') || '';
        const choices = new Choices(yearSelect, {
            searchEnabled: false
        });
        allChoices[yearSelect.name] = choices;
    }
    if (genreSelect) {
        genreSelect.value = getQueryParam('genre') || '';
        const choices = new Choices(genreSelect, {
            searchEnabled: false
        });
        allChoices[genreSelect.name] = choices;
    }
    if (availableToWatchCheckbox) {
        availableToWatchCheckbox.checked = getQueryParam('availableToWatch') === 'true';
    }
    if (formatSelect?.value || yearSelect?.value || genreSelect?.value || availableToWatchCheckbox?.checked) {
        expandFilterMenu(elements.expandableFilter);
    }
    return { allChoices };
};
